export function getMonday() {
  const d = new Date();
  var day = d.getDay(),
    diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}

export function formatDateUTC(date: Date) {
  return date.toLocaleDateString('en-US', {timeZone: 'UTC'});
}

export function getGithubLink(prString: string) {
  let prID = prString;
  let prLink = "";
  if (prString.includes("/")) {
    const prParts = prString.split("/");
    prID = prParts[prParts.length - 1];
  } else if (prString.startsWith("#")) {
    prID = prString.slice(1);
  }
  if (prString.includes("http")) {
    prLink = prString;
  } else {
    prLink = `https://github.com/firebase/firebase-js-sdk/pull/${prID}`;
  }
  return <a href={prLink} target="_blank" rel="noreferrer">#{prID}</a>;
}

export function getCritiqueLink(clString: string) {
  let clID = clString;
  let clLink = "";
  if (clString.includes("/")) {
    const clParts = clString.split("/");
    clID = clParts[clParts.length - 1];
  }
  if (clString.includes("http")) {
    clLink = clString;
  } else {
    clLink = `https://critique-ng.corp.google.com/cl/${clID}`;
  }
  return <a href={clLink} target="_blank" rel="noreferrer">cl/{clID}</a>;
}

export function compareVersions(versionA: string, versionB: string) {
  const aParts = versionA.split('.');
  const bParts = versionB.split('.');
  const aNums = [];
  const bNums = []
  for (let i = 0; i < 3; i++) {
    aNums[i] = aParts[i] ? parseInt(aParts[i], 10) : 0;
    bNums[i] = bParts[i] ? parseInt(bParts[i], 10) : 0;
    if (aNums[i] > bNums[i]) {
      return -1;
    }
    if (aNums[i] < bNums[i]) {
      return 1;
    }
  }
  return 0;
}